import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Hier kommt Niklas!'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-niklas-09_tlf3pc',
    alt: 'dasProject Foto Niklas',
    aspectRatio: 1.5
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-niklas-07_mlwgme',
    alt: 'dasProject Foto Niklas',
    aspectRatio: 1.5
  }
]

const color = 'purple'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Niklas' next={8} previous={6}/>
      </div>
    )
  }
}

exports.data = {
  color: 'purple',
  number: 8
}



// WEBPACK FOOTER //
// ./niklas.js